  var cookiename = "WY1ljtmrVOaSoKFrF94DaebGcZnGbfDD5hOPYGwrkCUFrgNcePfB2uhZRLpfMd87h"
  var bypassloginflags = [  "*?&bl=5426*",  "*?&bl=gift*" , "*?oseid=*", "*?_ab=0&_bt=*"]
  
  //Add Session Cookie for bypassed login
  if(getCookie(cookiename) == '' && url_matches(bypassloginflags) == true){
    setCookie(cookiename, 'true', 0);
  }

  //Show Password screen if no 'BypassLogin' present and cookie not present.
  if(getCookie(cookiename) == '' && url_matches(bypassloginflags) == false){
      
     $("body").hide();
     $('body').before(`
                        <div id='loginform' style=" 
                        text-align: -webkit-center;
                        background: url(https://campustradingglobal.com/shopify/global-images/background.jpg);
                        color: #ffffff;
                        background-color: #000000;
                        background-repeat: no-repeat;
                        background-attachment: fixed;
                        width:100%;
                        position: absolute;
                        background-size: cover;
                        height: 100%;">

                          <main id="main-holder" style="width: 280px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);background-color: black;box-shadow: 1px 1px 51px 50px rgb(0 0 0);">
                            <img class="password-logo" src="https://campustradingglobal.com/shopify/global-images/ct-logo.png" style="padding-bottom: 20px;">
 <h3 id="HeaderMessage" class="password-page-message" style="color: #ffffff;padding-bottom: 43px;">Welcome.</h3>
                            <h1 id="login-header" style="color: #ffffff;font-size: 13px;font-weight: 700;line-height: 28px;">This is a Members only store.<br>
                            Please enter your Membership ID.</h1>

                            <div id="login-error-msg-holder">
<p class="subtitle" id="login-error-msg" style="color:red;">Invalid username <span id="error-msg-second-line">and/or password</span></p>
                            </div>

                      
                            <form id="login-form">
                              <input type="text" name="username" id="username-field" hidden="hidden" value="Campus&Co. Membership ID">
                              <input type="password" name="password" id="password-field" class="login-form-field" placeholder="Membership ID">
                              <input type="submit" value="Enter Store" id="login-form-submit">
                            </form>


 
    <h1 style="color: #ffffff;font-size: 13px;font-weight: 700;border-top: 1px solid #aeaeb0;line-height: 28px;">Need a Member ID? <br><a id="password-link" href="#">Click here</a> to request one.</h1>

                          </main>


                          </div>
      `);
      $("#login-error-msg-holder").hide();
      $("#username-field").hide()
      $('#login-form-submit').click(function(e){
        e.preventDefault();

        if( hash($('#password-field').val()) == -1706299550){
          setCookie(cookiename, 'true', 365);
          $("#password-field").hide();
          $("#login-form-submit").hide();
          alert("\nThis site has now been updated! \n\nYou no-longer need to enter this 'Membership ID' every time you visit! \n\nYour login will be automatically remembered for 1 year on this device.");
          location.reload();
        }else{
          $("#login-error-msg-holder").show();
          $("#login-error-msg").html("INCORRECT MEMBER ID");
          $("#password-field").val("");
          $("#password-field").focus();
        }
        
        $("body").addClass("removeMe");
      });
    
      $('body').bind('DOMSubtreeModified', function(){
        $("body").hide();
        $("body").addClass("removeMe");
      });
        
      $(document).ready(function(){
        $('#password-link').attr("href","mailto:" + $('#shopemail').html());
        $('#HeaderMessage').html("Welcome to " + $('#shopname').html());
        $(".removeMe").remove();
      }); 
    
  }
  
  //-------------COMMON FUNCTIONS -------------------------------------

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    if(exdays == 0){
      document.cookie = cname + "=" + cvalue + ";path=/";
    }else{
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

    function hash(input) {
        var hash = 0, i, chr;
        if (input.length === 0) return hash;
        for (i = 0; i < input.length; i++) {
            chr = input.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        //alert(hash);
        return hash;
    };

function url_matches(targets) {
	var i
	for (i=0; i<targets.length; i++) {
	  if ((new RegExp(targets[i].replace(/\*/g, "[^ ]*"))).test(window.location.href)) {
	    return true;
	  }
	}
	return false;
}